import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { selectLanguageBasedOnBrowserLocale } from './localeUtils'
import moment from './momentLocale'
import translations from './translations'

export const initTranslations = () => {
  const language = navigator.language.split('-')[0]
  const currentLang = localStorage.getItem('i18nextLng')

  if (!currentLang) {
    localStorage.setItem('i18nextLng', language)
  }

  i18n.use(initReactI18next).init({
    fallbackLng: currentLang || 'pl',
    resources: translations,
    interpolation: {
      escapeValue: false,
    },
  })

  return i18n
}

const localeInstance = initTranslations()

export { selectLanguageBasedOnBrowserLocale, translations, moment, localeInstance }
